import axios from 'axios';
import { BranchListAction, CompanyListAction, CRMData, OpprtunityBySlpCode, outGoingPaymentAction, setItemGroup, setItems } from './actions';
import { getBranch, getCartItemApi, getCompany, getCrmData,GetSQItems, getItem, getItemGroup, getItemMaster, getOutGoingPayment, CustomerFollowUp } from '../API/API';
import { setCart } from './userReducer';
import { GetData } from '../API/getApi';

export const fetchItemGroup = (databaseName, jwtToken) => async (dispatch, navigate) => {
  const response = await GetData(getItemGroup + databaseName, {
    headers: {
      'wg_token': jwtToken
    }
  }, dispatch, navigate);
  dispatch(setItemGroup(response));
};

// export const fetchItems = async (databaseName, jwtToken, dispatch, navigate) => {
//   const response = await GetData(getItem + databaseName, {
//     headers: {
//       'wg_token': jwtToken
//     }
//   }, dispatch, navigate);
//   return response;
// };

export const fetchOutGoingPayment = (userId, databaseName, jwtToken) => async (dispatch, navigate) => {
  const response = await GetData(getOutGoingPayment + databaseName + '&userId=' + userId, {
    headers: {
      'wg_token': jwtToken
    }
  }, dispatch, navigate);
  dispatch(outGoingPaymentAction(response));
}
export const fetchGetCRMData = async (databaseName, jwtToken, dispatch, navigate) => {
  const response = await GetData(getCrmData + databaseName, {
    headers: {
      'wg_token': jwtToken
    }
  }, dispatch, navigate);
  return response; // Return the resolved response directly
};
export const fetchCart = (userId, jwtToken) => async (dispatch, navigate) => {
  try {
    const response = await GetData(getCartItemApi+ 'userId=' + userId, {
      headers: {
        'wg_token': jwtToken
      }
    }, dispatch, navigate);
    dispatch(setCart(response));
  } catch (error) {
    throw new Error(error.message);
  } 
}
export const fetchCompanyList =(user, jwtToken) => async (dispatch, navigate) => {
  const response = await GetData(getCompany + user, {
    headers: {
      'wg_token': jwtToken
    }
  });
  dispatch(CompanyListAction(response));
}

export const fetchBranchList =(databaseName, jwtToken) => async (dispatch, navigate) => {
  const response = await GetData(getBranch + databaseName, {
    headers: {
      'wg_token': jwtToken
    }
  });
  dispatch(BranchListAction(response));
}
export const fetchSQItemByDocEntry = (item, jwtToken, location) => async (dispatch, navigate) => {
  try {
    const response = await GetData(`${GetSQItems}DocEntry=${item.DocEntry}`, {
      headers: {
        'wg_token': jwtToken
      }
    });
    // console.log("dicsdcks",response);
    
    // const { additionalData } = location.state || {};
    // if (additionalData === 'sqUpdate') {
      const cartItemsObject = response.reduce((acc, item) => {
        acc[item.itemCode] = item;  
        return acc;
      }, {});
      // console.log("cartItemsObject :", response);
      
      dispatch(setCart(response));
    // }
    // return response;
  } catch (error) {
    console.error("Error fetching SQItems:", error);
  }
};
// export const fetchOpprtunity = (databaseName, jwtToken, SlpCode, accessLevel) => async (dispatch) => {
//   try {
//     const response = await GetData(
//       `${CustomerFollowUp}?databaseName=${databaseName}&slpCode=${SlpCode}&accessLevel=${accessLevel}`,
//       {
//         headers: {
//           'wg_token': jwtToken
//         }
//       }
//     );
//       dispatch(OpprtunityBySlpCode(response)); // dispatch only the data array 
//   } catch (error) {
//     console.error("Error fetching opportunity data:", error);
//     dispatch(OpprtunityBySlpCode([]));
//   }
// };